module.exports = __webpack_public_path__ + "img/filter.7ca4508e.svg";